import { render, staticRenderFns } from "./LogoBarBase.vue?vue&type=template&id=7be966c2&scoped=true"
import script from "./LogoBarBase.vue?vue&type=script&lang=js"
export * from "./LogoBarBase.vue?vue&type=script&lang=js"
import style0 from "./LogoBarBase.vue?vue&type=style&index=0&id=7be966c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be966c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7be966c2')) {
      api.createRecord('7be966c2', component.options)
    } else {
      api.reload('7be966c2', component.options)
    }
    module.hot.accept("./LogoBarBase.vue?vue&type=template&id=7be966c2&scoped=true", function () {
      api.rerender('7be966c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/LogoBarBase.vue"
export default component.exports